/** * @author ❤️❤️❤️ FightFastest 🤎🤎🤎 * @date 🚙 🚒 🛺 7/3/2022 下午 2:09 下午 1:57 🚌 🚄 🚈 🚝 */
<template>
	<div class="box">
		<!-- 可供拖拽的元素 -->
		<div draggable="true" @dragstart="dragstart($event, item)" @dragend="dragend($event, item)" v-for="(item, index) in items" :key="index" class="drop-field-img">
			<span class="item"> {{ item.moveIndex }}</span>
			<img :src="item.img" class="pic" />
		</div>

		<div class="drop-field">
			<div v-for="(item, targetIndex) in targetItems" :key="item.targetIndex" @dragover.prevent @dragenter="ggg" class="drop-field-item">
				<div class="empty-box" @drop="drop(item, targetIndex)" @dragenter="itemdragover(item, targetIndex)">
					<img :src="item.img" class="pic" v-if="item.img !== ''" />
				</div>
				{{ item.targetIndex }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			items: [
				{ moveIndex: 1, label: '兔崽子', img: 'https://randomuser.me/api/portraits/women/18.jpg' },
				{ moveIndex: 2, label: 'pen', img: 'https://randomuser.me/api/portraits/men/20.jpg' },
				{ moveIndex: 0, label: '猴子', img: 'https://randomuser.me/api/portraits/men/41.jpg' }
			],
			currentImageUrl: '',
			targetItems: [
				{ targetIndex: 0, img: '' },
				{ targetIndex: 2, img: '' },
				{ targetIndex: 1, img: '' }
			],
			currentMoveIndex: '',
			targetItem: '',
			emptyIndex: '',
			isPlay: false, // 控制音频的播放
			correctNumber: 0, // 统计正确安放的图片数量
			allSuccess: false
		}
	},
	mounted() {},

	methods: {
		itemdragover(item, targetIndex) {
			console.log(item, targetIndex)
		},
		ggg() {
			console.log(88888)
		},
		drop(event, index) {
			console.log('drop', event.targetIndex, index)
			this.emptyIndex = event.targetIndex
			console.log('移到空白位置索引', this.emptyIndex)
		},
		dragstart(event, item) {
			console.log('dragstart的索引', item.moveIndex)
			// 开始移动的时候将移动的索引值+图片的url存储下来
			this.currentMoveIndex = item.moveIndex
			this.currentImageUrl = item.img
		},
		dragend(event, item) {
			console.log('dragend', item)
			console.log('dragend的索引', this.currentMoveIndex)
			// 校对移动的元素和当前移入到的元素索引是否匹配
			if (this.emptyIndex === this.currentMoveIndex) {
				let index = this.targetItems.findIndex(v => v.targetIndex === this.currentMoveIndex)
				// 如果是则给图片列表中对应索引的img赋值
				this.targetItems[index].img = this.currentImageUrl
				// 同时计算成功的数量
				this.calculateNumber()
				// 如果是移动到正确的位置就产生音效
				// document.getElementById('audioMusic').play()
			} else {
				console.log('不在指定位置')
			}

			if (this.correctNumber === this.items.length) {
				this.allSuccess = true
				setTimeout(() => {
					this.allSuccess = false
				}, 3000)
			}
			event.dataTransfer.clearData()
		},
		calculateNumber() {
			this.correctNumber += 1
			console.log('正确放置的元素数', this.correctNumber)
		}
	}
}
</script>

<style lang="less" scoped>
.success-box {
	position: absolute;
	left: 500px;
	top: 0;
	img {
		opacity: 1;
	}
}
.show-animate img {
	animation: move 3s linear infinite;
}
@keyframes move {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
	100% {
		opacity: 0;
	}
}
.box {
	display: flex;
	justify-content: center;
}
.item {
	width: 150px;
	height: 150px;
	background: rgb(241, 241, 225);
}
.drop-field {
	width: 300px;
	background: lavender;
	padding: 20px;

}
.drop-field-img{
	&:hover{
		cursor: move;
		//pointer-events: all;
	}
}
.pic {
	width: 100px;
	height: 100px;
}
.empty-box {
	width: 100px;
	height: 100px;
	background: white;
}
.drop-field-item{
	border: 1px solid red;
	//&:hover{
	//
	//}
}
</style>
